import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import GalleryView from '../views/GalleryView.vue'
import RegistrationView from '../views/RegistrationView.vue'
import AdminDancers from '../views/administration/AdminDancers.vue'
import LogIn from '../views/administration/LogIn.vue'
import EditText from '../views/administration/EditText.vue'
import TestView from '../views/TestView.vue'
import store from '../store/index.js'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/galery',
    name: 'gallery',
    component: GalleryView
  },
  {
    path: '/test',
    name: 'test',
    component: TestView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/registration',
    name: 'registration',
    component: RegistrationView
  },
  {
    path: '/admin/admindancers',
    name: 'admindancers',
    component: AdminDancers,
    meta: {
      requiresUser: true
    }
  },
  {
    path: '/admin/edittext',
    name: 'edittext',
    component: EditText,
    meta: {
      requiresUser: true
    }
  },
  {
    path: '/admin',
    name: 'login',
    component: LogIn,
    meta: {
      redirectWhenAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.redirectWhenAuth)) {
    if (store.state.token === 'spoiujhbvcftgzu1234kjihjb654gGHc') {
      next({
        path: '/admin/admindancers'
      })
    } else {
      next()
    }
  } else if (to.matched.some((record) => record.meta.requiresUser)) {
    if (store.state.token === '') {
      next({
        path: '/admin'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})
export default router
